window.addEventListener("load", () => {
  const url = new URL(window.location.href);
  const cartForm = document.querySelector("#cartFrom1");
  const submitBtn = document.querySelector("#submitCart");
  
  submitBtn.addEventListener('click', (e) => {
    const result = checkLineItemValidation();
    if (!result.validationFlag) {
      alert(`※入力内容に不備があります。${result.wristValidationError ? "\n手首サイズを選択してください。" : ""}${result.markValidationError ? "\n刻印情報を入力してください。" : ""}`);
      e.preventDefault();
      return false;
    }
    if (loginStatus) {
      submitBtn.removeAttribute("onclick");
      submitBtn.removeAttribute("onsubmit");
      submitBtn.setAttribute("type", "submit");
      cartForm.setAttribute("method", "post");
    }
  });

  //刻印文字
  const markTypeSelectors = document.querySelectorAll(".mark-initial-flex-item input[type='radio']");
  if (markTypeSelectors) {
    for (const radio of markTypeSelectors) {
      // init
      const itemContainer = radio.closest('.cart__item');
      if (radio.checked) {
        enableInitialInput(itemContainer, radio.value);
      }

      radio.addEventListener("change", async (e) => {
        if (e.target.checked) {
          enableInitialInput(itemContainer, e.target.value);
          await updateLineProperty(itemContainer);
        }
        const initialUsageSelect = itemContainer.querySelector(".property-initial-usage");
        initialUsageSelect.value = "";
      })
    }
  }

  // 文字入力欄 
  const markLetterInputs = document.querySelectorAll(".mark-initial-flex-item input[type='text']");
  if (markLetterInputs) {
    for (const input of markLetterInputs) {
      input.addEventListener("change", async (e) => {
        const itemContainer = input.closest('.cart__item');
        await updateLineProperty(itemContainer);
      })
    }
  }

  //字体
  const markSelectUsage = document.querySelectorAll("select.property-initial-usage");
  if (markSelectUsage) {
    for (const select of markSelectUsage) {
      select.addEventListener("change", async (e) => {
        if (e.target.value != "") {
          const itemContainer = select.closest('.cart__item');
          await updateLineProperty(itemContainer);
        }
      })
    }
  }
  //手首サイズ  
  const sizeSelectores = document.querySelectorAll(".property-wrist-size");
  if (sizeSelectores) {
    for (const select of sizeSelectores) {
      // init
      select.addEventListener("change", async (e) => {
        console.log(`wristSize: ${e.target.value}`);
        const itemContainer = select.closest('.cart__item');
        await updateLineProperty(itemContainer);
      })
    }
  }

  const initialFormClearButton = document.querySelectorAll(".initial-clear__button");
  if (initialFormClearButton) {
    for (const button of initialFormClearButton) {
      button.addEventListener("click", async (e) => {
        const itemContainer = button.closest('.cart__item');
        // console.log('itemContainer:', itemContainer);
        // console.log('data-line:', itemContainer?.dataset.line);
        clearMarkForm(itemContainer);
        await updateLineProperty(itemContainer);
      })
    }
  }

  const wrappingCheckbox = document.getElementById("orderWrapping");
  if (wrappingCheckbox) {
    wrappingCheckbox.addEventListener('change', (e) => {
      let wrappingValue = "必要";
      if (e.target.checked === false) {
        wrappingValue = "不要";
      }
      updateOrderWrappingAttribute(wrappingValue);
    })
  }

  const cartNote = document.getElementById("CartNote");
  if (cartNote) {
    cartNote.addEventListener('change', (e) => {
      updateOrderNote(e.target.value);
    })
  }

  // 半角全角の判定
  // 半角英数字は0.5文字、全角は1文字としてカウント
  const isFullWidth = ch => /[^\u0020-\u007E]/.test(ch);
  function truncateString(str, maxWidth) {
    let width = 0;
    let result = [];

    for (const ch of Array.from(str)) {
      const w = isFullWidth(ch) ? 1 : 0.5;
      if (width + w > maxWidth) break;
      result.push(ch);
      width += w;
    }
    return result.join('');
  }

  // 文字数制限
  // data-maxlength属性を持つinput要素を取得
  const maxLengthInputs = document.querySelectorAll("input[data-maxlength]");
  if (maxLengthInputs) {
    maxLengthInputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        const maxWidth = parseFloat(input.dataset.maxlength);
        input.value = truncateString(input.value, maxWidth);
      })
    })
  }

})

function enableCartButton() {
  const checkoutButton = document.querySelectorAll("button.cart__checkout");
  for (button of checkoutButton) {
    button.classList.remove("disenable-function");
  }
}
function disenableCartButton() {
  const checkoutButton = document.querySelectorAll("button.cart__checkout");
  for (button of checkoutButton) {
    button.classList.add("disenable-function");
  }
}

function disenableInitialInput(container) {
  const lettersSend = container.querySelector(".initial-letters-linear");
  const lettersOwn = container.querySelector(".initial-letters-circular");
  const selectUsage = container.querySelector(".property-initial-usage");
  lettersSend.classList.add("disenable-function");
  lettersOwn.classList.add("disenable-function");
  selectUsage.classList.add("disenable-function");
}

// 初期値の選択肢を有効化
function enableInitialInput(container, checkedValue) {
  const lettersSend = container.querySelector(".initial-letters-linear");
  const lettersOwn = container.querySelector(".initial-letters-circular");
  const selectUsage = container.querySelector(".property-initial-usage");
  const initialCursive = container.querySelector("option[data-initial=cursive]");
  if (checkedValue === "横彫") {
    lettersSend.classList.remove("disenable-function");
    lettersOwn.classList.add("disenable-function");
    if (initialCursive) {
      initialCursive.disabled = false;
    }
  } else if (checkedValue === "丸彫") {
    lettersSend.classList.add("disenable-function");
    lettersOwn.classList.remove("disenable-function");
    if (initialCursive) {
      initialCursive.disabled = true;
    }
  }
  selectUsage.classList.remove("disenable-function");
}

function clearMarkForm(itemContainer) {
  const markType = itemContainer.querySelector(".mark-initial-flex-item input[type='radio']:checked");
  const linearInital1 = itemContainer.querySelector("input.initial-letter-input__linear1");
  const linearInital2 = itemContainer.querySelector("input.initial-letter-input__linear2");
  const circularInital1 = itemContainer.querySelector("input.initial-letter-input__circular1");
  const circularInital2 = itemContainer.querySelector("input.initial-letter-input__circular2");
  const circularInital3 = itemContainer.querySelector("input.initial-letter-input__circular3");
  const initialUsage = itemContainer.querySelector("select.property-initial-usage");
  if (markType) {
    markType.checked = false;
    linearInital1.value = "";
    linearInital2.value = "";
    circularInital1.value = "";
    circularInital2.value = "";
    circularInital3.value = "";
    initialUsage.value = "";
    disenableInitialInput(itemContainer);
  }
}


// 空のプロパティを削除する関数
function removeEmptyProperties(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
  );
}


async function updateLineProperty(itemContainer) {
  console.log('updateLineProperty: start');
  disenableCartButton();
  const productLine = itemContainer.dataset.line;
  // console.log('updateLineProperty: productLine', productLine);
  // console.log('itemContainer:', itemContainer);
  const wristSize = itemContainer.querySelector(`select[name='properties[手首サイズ]_item${productLine}']`);
  const markType = itemContainer.querySelector(`input[name='properties[刻印文字]_item${productLine}']:checked`);
  console.log('markType:', markType);
  const linearInital1 = itemContainer.querySelector(`input[name='properties[横彫1]_item${productLine}']`);
  console.log('linearInital1:', linearInital1);
  const linearInital2 = itemContainer.querySelector(`input[name='properties[横彫2]_item${productLine}']`);
  const circularInital1 = itemContainer.querySelector(`input[name='properties[丸彫1]_item${productLine}']`);
  const circularInital2 = itemContainer.querySelector(`input[name='properties[丸彫2]_item${productLine}']`);
  const circularInital3 = itemContainer.querySelector(`input[name='properties[丸彫3]_item${productLine}']`);
  const initialUsage = itemContainer.querySelector(`select[name='properties[字体]_item${productLine}']`);

 const wristData = wristSize ? { '_手首サイズ': wristSize.value } : { '_刻印': 'なし' };

 let markData = {};
  // 刻印データ: 必ず全キーを持ち、未使用はnull
  if (markType) {
    markData = {
      '_刻印文字': '',
      '_横彫1行目': '',
      '_横彫2行目': '',
      '_丸彫1行目': '',
      '_丸彫2行目': '',
      '_丸彫3行目': '',
      '_字体': ''
    };
  }
  

  if (markType && markType.value === '横彫') {
    markData['_刻印'] = '';
    markData['_刻印文字'] = markType.value;
    markData['_横彫1行目'] = linearInital1.value;
    markData['_横彫2行目'] = linearInital2.value;
    markData['_字体'] = initialUsage.value;
  } else if (markType && markType.value === '丸彫') {
    markData['_刻印'] = '';
    markData['_刻印文字'] = markType.value;
    markData['_丸彫1行目'] = circularInital1.value;
    markData['_丸彫2行目'] = circularInital2.value;
    markData['_丸彫3行目'] = circularInital3.value;
    markData['_字体'] = initialUsage.value;
  }

  // 空のプロパティを除外
  const cleanedProperties = removeEmptyProperties({ ...wristData, ...markData });
  // 
  const propertiesToSend = Object.keys(cleanedProperties).length > 0 ? cleanedProperties : null;


  console.log('updateLineProperty: properties', propertiesToSend);
  const formData = {
    "line": Number(productLine),
    'properties': propertiesToSend
  }

  disableRemoveButton(itemContainer.dataset.productId);

  await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then(async (response) => {
      const json = await response.json();
      // console.log('updateLineProperty: response json', json);
      enableRemoveButton(json.items);
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
      enableRemoveButton(itemContainer.dataset.productId, itemContainer.dataset.key, previousHref)
    });
}

// アイテム削除ボタンを無効化
function disableRemoveButton(productId) {
  let itemContainers = document.querySelectorAll('.cart__item-details');

  itemContainers.forEach((itemContainer) => {
    let removeButton = itemContainer.querySelector('.cart__item-header')
      .querySelector('.cart__item-price-col')
      .querySelector('.cart__remove')
      .querySelector('.text-link');

    removeButton.removeAttribute('href');
  });
}

// アイテム削除ボタンを有効化
function enableRemoveButton(items) {
  items.forEach((item) => {
    const itemDiv = document.querySelector('[data-product-id="' + item.id + '"]');
    let removeButton = itemDiv.querySelector('.cart__item-details')
      .querySelector('.cart__item-header')
      .querySelector('.cart__item-price-col')
      .querySelector('.cart__remove')
      .querySelector('.text-link');

    removeButton.setAttribute('href', '/cart/change?id=' + item.key + '&quantity=0');
  });
}

function updateOrderNote(value) {
  disenableCartButton();
  const formData = {
    note: value,
  }
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => {
      // console.log(response.json());
      document.getElementById("orderNoteInfo").innerText = value;
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function updateOrderWrappingAttribute(value) {
  console.log(`updateOrderWrappingAttribute: ${value}`);
  disenableCartButton();
  const formData = {
    attributes: {
      'ラッピング': value
    }
  }
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => {
      // console.log(response.json());
      document.getElementById("wrappingInfo").innerText = value;
      document.getElementById("orderWrapping").value = value;
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function updateOrderDeliveryWayAttribute(value) {
  disenableCartButton();
  const formData = {
    attributes: {
      'ラッピング': value
    }
  }
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => {
      // console.log(response.json());
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function updateOrderShopInfoAttribute(value) {
  disenableCartButton();
  const formData = {
    attributes: {
      'ラッピング': value
    }
  }
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      'Content-Type': "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => {
      // console.log(response.json());
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

//バリデーション
function checkLineItemValidation() {
  let validationFlag = true;
  let wristValidationError = false;
  let markValidationError = false;
  let initialTypeError = false;
  const cartItems = document.querySelectorAll(".cart__page-col .cart__item");
  const errorTexts = document.querySelectorAll(".line-error-text");
  if (errorTexts) {
    for (const text of errorTexts) {
      text.remove();
    }
  }
  for (const item of cartItems) {
    const wristSize = item.querySelector(".wrist-size");
    const initialTypeChecked = item.querySelector(".mark-initial-flex-item input[type='radio']:checked");

    // 手首サイズのチェック
    if (wristSize) {
      (function () {
        // check wristSize validate
        const wristSizeValue = wristSize.querySelector("select.property-wrist-size").value;
        // console.log(`wristSizeValue: ${wristSizeValue}`);
        if (!wristSizeValue) {
          const error = document.createElement("p");
          error.classList.add("line-error-text", "font-gothic");
          error.innerText = "※手首サイズを選択してください";
          wristSize.after(error);
          wristValidationError = true;
          validationFlag = false;
        }
      }());
    }

    // 刻印情報のチェック
    if (initialTypeChecked) {
      (function () {
        const markUsageSelect = item.querySelector("select.property-initial-usage");
        const fontValue = markUsageSelect ? markUsageSelect.value : "";
        let initial1 = null;

        // 刻印タイプによる入力欄の取得
        if (initialTypeChecked.value === "横彫") {
          initial1 = item.querySelector("input.initial-letter-input__linear1");
        } else if (initialTypeChecked.value === "丸彫") {
          initial1 = item.querySelector("input.initial-letter-input__circular1");
        }

        // 入力必須チェック
        if (!initial1 || !initial1.value || initial1.value.trim() === "") {
          const markContainer = item.querySelector(".mark-initial-flex-item1");
          const error = document.createElement("p");
          error.classList.add("line-error-text", "font-gothic");
          error.innerText = "１行目に刻印文字を入力してください";
          markContainer.appendChild(error);
          markValidationError = true;
          validationFlag = false;
        } else {
          // 字体によるバリデーション（全行）
          const markUsageSelect = item.querySelector("select.property-initial-usage");
          const fontValue = markUsageSelect ? markUsageSelect.value : "";
          // チェック対象の全行inputを取得
          let initialInputs = [];
          if (initialTypeChecked.value === "横彫") {
            initialInputs = [
              item.querySelector("input.initial-letter-input__linear1"),
              item.querySelector("input.initial-letter-input__linear2")
            ];
          } else if (initialTypeChecked.value === "丸彫") {
            initialInputs = [
              item.querySelector("input.initial-letter-input__circular1"),
              item.querySelector("input.initial-letter-input__circular2"),
              item.querySelector("input.initial-letter-input__circular3")
            ];
          }
          let allowedRegex, errorMsg;
          if (fontValue === "ゴシック体") {
            allowedRegex = /^[\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FFa-zA-Z\uFF21-\uFF3A\uFF41-\uFF5A0-9\uFF10-\uFF19&＆.．\s　]*$/;
            errorMsg = "※選択された字体では使用できない文字が含まれています。\n漢字、ひらがな、カタカナ、アルファベット（a-zまたはA-Z）、数字（0-9）、記号（＆　．）、スペース（空白）からお選びください";
            initialTypeError = true;
          } else {
            allowedRegex = /^[a-zA-Z\uFF21-\uFF3A\uFF41-\uFF5A0-9\uFF10-\uFF19&＆.．\s　]*$/;
            errorMsg = "※選択された字体では使用できない文字が含まれています。\nアルファベット（a-zまたはA-Z）、数字（0-9）、記号（＆　．）、スペース（空白）からお選びください";
            initialTypeError = true;
          }
          // 各行でバリデーション
          initialInputs.forEach((input, idx) => {
            if (input && input.value && !allowedRegex.test(input.value)) {
              const markContainer = item.querySelector(".mark-initial-flex-item1");
              const error = document.createElement("p");
              error.classList.add("line-error-text", "font-gothic");
              error.innerText = `※${idx + 1}行目：${errorMsg}`;
              markContainer.appendChild(error);
              markValidationError = true;
              validationFlag = false;
            }
          });
        }

        // 字体未選択チェック
        if (!fontValue) {
          const markContainer = item.querySelector(".mark-initial-flex-item2");
          const error = document.createElement("p");
          error.classList.add("line-error-text", "font-gothic");
          error.innerText = "※字体を選択してください";
          markContainer.appendChild(error);
          markValidationError = true;
          validationFlag = false;
        }
      }());
    }
  }

  return {
    validationFlag: validationFlag,
    wristValidationError: wristValidationError,
    markValidationError: markValidationError,
    initialTypeError: initialTypeError
  };
}

function isCartInMarkInitial() {
  let isCartInInitial = false;
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      for (const item of data.items) {
        if (item.properties.hasOwnProperty('刻印文字')) {
          isCartInInitial = true;
        }
      }
      if (isCartInInitial) {
        const deliveryModule = document.getElementById("deliver-date-module");
        if (deliveryModule) {
          deliveryModule.classList.add("no-content");
          // delete deliver selected value
          const dateSelect = deliveryModule.querySelector("select[name='delivery_date']");
          if (dateSelect) {
            dateSelect.value = "";
          }
          const timeSelect = deliveryModule.querySelector("select[name='delivery_time']");
          if (timeSelect) {
            timeSelect.value = "";
          }
        }
      } else {
        const deliveryModule = document.getElementById("deliver-date-module");
        if (deliveryModule) {
          deliveryModule.classList.remove("no-content");
        }
      }
    })
    .catch((error) => {
      console.error("Error", error);
    })
}